// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useRef } from "react";
import moment from "moment";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import Calendar from "./Calendar";

function ClearwayCalendar({data, date, onEventClick}) {

    var ref = useRef(null);
    
    // console.log(data)

    return (
        <SoftBox>
            <Grid item xxs={12} xl={12} sx={{ height: "max-content" }}>
                <Calendar
                    initialView="dayGridMonth"
                    initialDate={date}
                    events={data}
                    selectable
                    editable
                    ref={ref}
                    eventClick={onEventClick}
                />
            </Grid>
        </SoftBox>
    );

}

// Typechecking props for the Calendar
ClearwayCalendar.propTypes = {
    data: PropTypes.array,
    date: PropTypes.instanceOf(moment()),
    onEventClick: PropTypes.func,
};


export default ClearwayCalendar;